import { render, staticRenderFns } from "./dialog-ticket-setting.vue?vue&type=template&id=6c89b9d5&scoped=true"
import script from "./dialog-ticket-setting.vue?vue&type=script&lang=js"
export * from "./dialog-ticket-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c89b9d5",
  null
  
)

export default component.exports